export default "__VITE_ASSET__Qbrw1mqp__"